import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=6442310a&scoped=true"
import script from "./RouterView.vue?vue&type=script&lang=js"
export * from "./RouterView.vue?vue&type=script&lang=js"
import style0 from "./RouterView.vue?vue&type=style&index=0&id=6442310a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442310a",
  null
  
)

export default component.exports